import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'
import { useAppSelector } from '@/redux/hooks'

// Libs
import { useFeedDataQuery } from '@/hooks/useFeedDataQuery'
import { useExploreVendorBlockData } from '@/hooks/useVendorBlockDataQuery'
import useMemberVips from '@/hooks/livemallclub/useMemberVips'

// Constants
import { TPreference } from '@/types/preference-tag'

// Components
import Loading from '@/components/common/livemallclub/Loading'
import Empty from '@/components/shared/livemallclub/Empty'
import ExploreLiveList from '@/components/shared/livemallclub/ExploreLiveList'
import UserStoryCarousel from '@/components/shared/livemallclub/UserStoryCarousel'
import Preferences from './components/Preferences'
import SearchResults from './components/Preferences/components/SearchResults'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)
interface PreferenceContextType {
  editModeSelectedData: TPreference[]
  setEditModeSelectedData: Dispatch<SetStateAction<TPreference[]>>
}

export const PreferenceContext = createContext<PreferenceContextType>({
  editModeSelectedData: [],
  setEditModeSelectedData: () => {
    throw new Error('setEditModeSelectedData function must be overridden by a Provider')
  },
})

export const usePreferenceContext = () => {
  const context = useContext(PreferenceContext)
  if (!context) {
    throw new Error('usePreferenceContext must be used within a PreferenceContext.Provider')
  }
  return context
}

const ExploreComponent = () => {
  const router = useRouter()
  const { keyword: keywordFromQuery } = router.query
  const { memberData } = useAppSelector((state) => state.member)
  const [editModeSelectedData, setEditModeSelectedData] = useState<TPreference[]>([])
  const { feedData, feedDataQuery, InfiniteScrollComponent } = useFeedDataQuery()
  const { exploreVendorBlockData } = useExploreVendorBlockData()
  const { data: vipShopList } = useMemberVips({ memberInfoId: memberData.memberInfoId })
  const isShowLoading = !feedDataQuery.isSuccess
  const isShowEmpty = !isShowLoading && feedData.length === 1 && !feedData?.[0]?.feeds
  const hasSearchResult = !!keywordFromQuery

  return (
    <div className={cx('explore')}>
      {isShowLoading && <Loading isFull={false} />}
      <PreferenceContext.Provider value={{ editModeSelectedData, setEditModeSelectedData }}>
        <Preferences />
      </PreferenceContext.Provider>
      {hasSearchResult && <SearchResults />}
      {!hasSearchResult && (
        <>
          <UserStoryCarousel users={exploreVendorBlockData} />
          <div className={cx('explore__live-list-wrapper')}>
            <InfiniteScrollComponent className={cx('explore__live-list')}>
              {isShowEmpty && <Empty type='explore' />}

              {feedData.map((feedData, currentPageIndex) => {
                // const refetchCurrentPage = () => {
                //   feedDataQuery.refetch({ refetchPage: (_, index) => index === currentPageIndex })
                // }
                // return <ExploreLiveList feeds={feedData?.feeds || []} key={currentPageIndex} refetchCurrentPage={refetchCurrentPage} />
                return (
                  <ExploreLiveList feeds={feedData?.feeds || []} key={currentPageIndex} useFavoriteState={true} vipShopList={vipShopList ?? []} />
                )
              })}
            </InfiniteScrollComponent>
          </div>
        </>
      )}
    </div>
  )
}

export default ExploreComponent
